/**
 * Endorsements section ID used for scrolling and navigation.
 * Used on petition details page.
 */
export const ENDORSEMENTS_SECTION_ID = 'endorsements-section';

/**
 * Hash fragment for endorsements section navigation.
 * Used with # prefix for URL navigation (e.g., #endorsements-section).
 */
export const ENDORSEMENTS_HASH = `#${ENDORSEMENTS_SECTION_ID}`;

/**
 * Hash fragment for endorsements section on petition edit pages.
 * Used for navigation in starter dashboard and petition edit flows.
 */
export const ENDORSEMENTS_EDIT_HASH = '#endorsements';
